var e,l;!function(e){e.small="small",e.medium="medium",e.large="large"}(e||(e={})),function(e){e.red="red",e.yellow="yellow",e.green="green",e.grey="grey",e.white="white",e.blue="blue"}(l||(l={}));export{l as TAGS_COLORS,e as TAGS_SIZES};
//# sourceMappingURL=FGTags.shared.js.map
